import { setDeviceGroups, setDeviceGroupsList } from "../../state/ducks";
import { dispatch } from "../../state/store";
import { deviceGroupUtils } from "../../utils";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_SHARED_CORE_URL;

const getRequestData = (endpoint) => {
  return `${apiUrl}/data/${endpoint}`;
};

const fetchGroups = async () => {
  const url = getRequestData("deviceGroup");

  const result = await httpClient.get(url);

  if (result?.data?.data) {
    const formattedDeviceGroups = deviceGroupUtils.formatDeviceGroups(result.data.data);
    dispatch(setDeviceGroups(formattedDeviceGroups));
  }
};

const createGroups = async (names) => {
  const url = getRequestData("deviceGroup");

  const data = {
    group_names: names
  };

  const result = await httpClient.post(url, { data });

  if (result?.data?.data) {
    return result?.data?.data;
  }
};

const updateGroup = async (id, name) => {
  const url = getRequestData("deviceGroup");

  const data = { group_id: id, group_name: name };

  await httpClient.put(url, { data });
};

const deleteGroup = async (id) => {
  const baseUrl = getRequestData("deviceGroup");
  const url = `${baseUrl}?group_id=${id}`;

  await httpClient.remove(url);
};

const fetchDeviceGroups = async () => {
  const url = getRequestData("deviceGroupRelation");

  const result = await httpClient.get(url);

  if (result?.data?.data) {
    const formattedDeviceGroupsList = deviceGroupUtils.formatDeviceGroupsList(result.data.data);
    dispatch(setDeviceGroupsList(formattedDeviceGroupsList));
  }
};

const updateDeviceGroups = async (dusn, groupIds) => {
  const url = getRequestData("deviceGroupRelation");

  const data = { dusn, group_ids: groupIds };

  await httpClient.post(url, { data });
};

const deleteDeviceGroup = async (dusn, groupId) => {
  const baseUrl = getRequestData("deviceGroupRelation");
  const url = `${baseUrl}?dusn=${dusn}&group_id=${groupId}`;

  await httpClient.remove(url);
};

const deviceGroupsService = {
  fetchGroups,
  createGroups,
  updateGroup,
  deleteGroup,
  fetchDeviceGroups,
  updateDeviceGroups,
  deleteDeviceGroup
};

export default deviceGroupsService;
